import { TextField, TextFieldProps } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { lang } from "i18nLang";
import PropTypes from "prop-types";

const alphabet: string[] = "ABCDEFGHIJKLMNOPQRSTUVWXZ".split("");

interface IProps {
  /** Propriedade name para identificar o input */
  name: string;
  /** Label que será exibida no input */
  label?: string;
  /** Valor atual do input */
  value: string;
  /** Função que será chamada no onChange do input */
  onChange: Function;
  /** Desabilita o input para edição */
  disabled: boolean;
  /** Propriedades extras do componente TextField do Material-UI */
  inputProps?: TextFieldProps;
}

/** Campo com valores e auto-complete para coluna Alfabéticas
 * @category Components
 */
const ColumnField = ({
  name,
  label,
  value,
  onChange,
  disabled,
  inputProps,
}: IProps) => {
  const handleChange = (ev, inputValue) => onChange(name, inputValue);

  const handleFilter = (currentOptions, { inputValue }) => {
    if (!inputValue) return Array.from(alphabet);

    const newOptions = alphabet.map((letter) => `${inputValue}${letter}`);
    newOptions.unshift(inputValue);

    return newOptions;
  };

  return (
    <Autocomplete
      options={alphabet}
      size="small"
      fullWidth
      freeSolo
      disabled={disabled}
      value={value}
      inputValue={value}
      onInputChange={handleChange}
      filterOptions={handleFilter}
      renderInput={(params) => (
        <TextField
          {...inputProps}
          {...params}
          label={label}
          name={name}
          onKeyDown={(ev) => ev.stopPropagation()}
          style={{ paddingTop: "0.38rem" }}
        />
      )}
    />
  );
};

ColumnField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ColumnField.defaultProps = {
  label: lang("column"),
};

export default ColumnField;
